import { useState } from 'react';
import type { NextPage } from 'next';
import { GetServerSideProps } from 'next';
import Image from 'next/image';
import Link from 'next/link';
import type { ShowroomAppProps } from 'pages/_app';
import Layout from 'layouts/Layout';
import TextInput from 'components/TextInput';
import SubmitButton from 'components/SubmitButton';
import axios from 'axios';

export const getServerSideProps: GetServerSideProps = async ({ req }) => {
  return {
    props: {},
  };
};

interface PageProps extends ShowroomAppProps {}

const SignupPage: NextPage<PageProps> = ({ isAuthenticated }) => {
  const [email, setEmail] = useState<string>('');
  const [valid, setValid] = useState<boolean>(true);
  const [loading, setLoading] = useState<boolean>(false);
  const [emailAlreadyTaken, setEmailAlreadyTaken] = useState(false);

  const handleOnSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    setLoading(true);
    setValid(true);
    setEmailAlreadyTaken(false);
    try {
      await axios.post('/api/auth/signup', { email });

      window.dataLayer?.push({
        event: 'signup',
      });

      window.location.href = '/';
    } catch (error: any) {
      if (Number(error?.response?.status) === 400 && error?.response?.data?.message === 'emailAlreadyTaken') {
        setEmailAlreadyTaken(true);
      }
      setLoading(false);
      setValid(false);
      console.log(error);
    }
  };

  return (
    <>
      <Layout title={'Skapa konto'} meta={[]} isAuthenticated={isAuthenticated} noFooter>
        <div className="container mt-4 mb-16">
          <div className="grid w-full gap-4 md:grid-cols-2">
            <div className="relative order-2 aspect-square md:order-1">
              <Image
                src={'/assets/Showroom_signup.jpg'}
                alt=""
                fill
                style={{ objectFit: 'cover' }}
                quality={100}
                priority
              />
            </div>
            <div className="order-1 flex flex-col px-4 md:order-2 lg:px-16">
              <div className="flex flex-1 flex-col justify-center">
                <form onSubmit={(e) => handleOnSubmit(e)} className="w-full">
                  <h2 className="heading-h2 mb-5">Skapa konto</h2>
                  {valid ? (
                    ''
                  ) : emailAlreadyTaken ? (
                    <div className="mb-3">Den här e-postadressen används redan.</div>
                  ) : (
                    <div className="mb-3">Något gick fel. Kolla din e-postadress.</div>
                  )}
                  <div className="mb-5">
                    <TextInput
                      border
                      hideLabel
                      id="email"
                      type="email"
                      label="Din e-postadress"
                      placeholder="Din e-postadress"
                      value={email}
                      error={!valid}
                      set={setEmail}
                    />
                  </div>
                  <SubmitButton label="Kom igång" loading={loading} />
                </form>
                <p className="my-6">
                  Genom att registrera ett konto godkänner du våra villkor{' '}
                  <Link href="/privacy-policy" className="underline">
                    Personuppgiftspolicy
                  </Link>
                </p>
              </div>
              <div className="flex flex-row border-t-[1px] border-black border-opacity-10 py-6">
                <p className="font-medium">Har du redan ett konto?</p>
                <div className="ml-1 font-normal underline">
                  <Link href="/login">Logga in</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Layout>
    </>
  );
};

export default SignupPage;
